<template>
	<div class="ui-mdf" @focusout="onFocusOut" tabindex="0">
		<div class="ui-mdf__elm" @click="onClick">
			<!-- SELECTED VALUE -->
			<div class="ui-mdf__elm-selected">
				<div class="ui-mdf__elm-selected-label">
					<div
						v-if="select === SELECT.EMPTY || select === SELECT.ALL"
					>
						{{ label }}
					</div>
					<div v-else>{{ select }}</div>
				</div>
				<IconChevronDown />
			</div>
		</div>

		<!-- Dropdown -->
		<div v-if="isShow" class="ui-mdf__list">
			<div class="ui-mdf__list-item" @click="onClickSelect('all', 0)">
				{{ dropdownDefaultLabel }}
			</div>
			<div class="ui-mdf__list-line"></div>
			<div
				@click="onClickSelect(item.name, item.id)"
				class="ui-mdf__list-item"
				v-for="(item, index) in items"
				:key="index"
			>
				{{ item.name }}
			</div>
		</div>

		<div class="ui-mdf__none">{{ selected }}</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";

@Options({
	components: { IconChevronDown },
	props: {
		label: { type: String, default: "" },
		dropdownDefaultLabel: { type: String, default: "Выбрать всё" },
		items: { type: Array },
		selectedId: { type: Number, default: 0 },
	},
})
export default class UiMobileDropdownFilter extends Vue {
	public items: Array<{ id: number; name: string }>;
	public selectedId: number;

	public SELECT = {
		EMPTY: "",
		ALL: "all",
	};

	public isShow = false;
	public select = "";

	/**
	 * Устанавливаем значение соответствующее selectedId
	 */
	public get selected() {
		for (let idx = 0; idx < this.items.length; idx++) {
			if (this.items[idx].id === this.selectedId) {
				this.select = this.items[idx].name;
				this.$emit("filter", this.items[idx].id);
				return this.selectedId;
			}
		}
		return 0;
	}

	/**
	 * Показываем/скрываем выпадающий список
	 */
	public onClick() {
		this.isShow = !this.isShow;
	}

	/**
	 * Выбор значения из выпадающего списка
	 * @param item
	 * @param id
	 */
	public onClickSelect(item: string, id: number) {
		this.isShow = !this.isShow;
		this.select = item;
		this.$emit("filter", id);
	}

	/**
	 * Скрываем выпадающий список, если кликнули за его пределами
	 */
	public onFocusOut() {
		this.isShow = false;
	}
}
</script>

<style scoped lang="scss">
.ui-mdf {
	user-select: none;
	position: relative;

	&__elm {
		padding: 12px;
		background: rgb(244, 246, 250);
		border-radius: 12px;
	}

	&__elm-selected-label {
		color: rgb(119, 121, 124);
		font-size: 16px;
	}

	&__elm-selected {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	&__list {
		position: absolute;
		top: 50px;
		width: 100%;
		padding: 8px 0;
		background: rgb(255, 255, 255);
		border: 1px solid rgb(221, 221, 221);
		border-radius: 12px;
		max-height: 150px;
		overflow-y: auto;
		scrollbar-width: thin;
		z-index: 1;
	}

	&__list-item {
		padding: 6px 12px;
		color: rgb(51, 51, 51);
		cursor: pointer;
	}

	&__list-item:hover {
		background: rgb(225, 225, 225);
		border-radius: 4px;
	}

	&__list-line {
		border-bottom: 1px solid rgb(243, 242, 242);
	}

	&__none {
		display: none;
	}
}
</style>
